import { render, staticRenderFns } from "./PropertiesEditor.vue?vue&type=template&id=1faf9474&scoped=true&"
import script from "./PropertiesEditor.vue?vue&type=script&lang=js&"
export * from "./PropertiesEditor.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesEditor.vue?vue&type=style&index=0&id=1faf9474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf9474",
  null
  
)

export default component.exports